import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MarkerWrapper from './MarkerWrapper';
import MarkerContent from './MarkerContent';

class MapWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      markerInfoLocation: false,
    };

    this.onMarkerInfoToggle = this.onMarkerInfoToggle.bind(this);
  }


  onMarkerInfoToggle(locationId) {
    if (locationId === this.state.markerInfoLocation) {
      return this.setState(() => ({
        markerInfoLocation: false,
      }));
    }

    return this.setState(() => ({
      markerInfoLocation: locationId,
    }));
  }

  getMarkers() {
    const { markerInfoLocation } = this.state;

    return this.props.markersArray.filter(e => (e.latitude && e.longitude)).map((data) => {
      const openByClick = (markerInfoLocation === data.id);

      return (
        <MarkerWrapper
          key={data.index}
          onInfoToggle={this.onMarkerInfoToggle}
          locationId={data.id}
          lat={data.latitude}
          lng={data.longitude}
          isActive={openByClick}
          labelIndex={data.index}
          colsY={data.colsY}
          rowX={data.rowX}
        >
          <MarkerContent
            area={data.localized_info.area}
            heading={data.localized_info.heading}
            desc={data.localized_info.desc}
            imageUrl={data.localized_info.image}
            link={data.url}
            showNewBadge={data.show_new_badge}
            state={data.state}
            stars_rating={data.stars_rating}
          />
        </MarkerWrapper>
      );
    });
  }

  render() {
    const markers = this.getMarkers();

    return (
      <div>
        {markers}
      </div>

    );
  }
}

MapWrapper.propTypes = {
  markersArray: PropTypes.arrayOf(PropTypes.shape),
};

MapWrapper.defaultProps = {
  markersArray: [],
};


export default MapWrapper;
